import React, { useRef, useState, useEffect } from "react";
import Moment from 'react-moment';
import 'moment/locale/es';
import moment from 'moment';
import { API } from "aws-amplify";
import Cookie from 'js-cookie';
import { Container, Row, Col, Button, Alert, Badge } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQrcode, faCheckCircle, faTimesCircle, faSpinner, faExclamationTriangle, faTicketAlt, faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import QrScanner from 'components/QrScanner';


import LoaderButton from "./LoaderButton";
import Loader from "./Loader";
import { onError, Notification } from "../libs/errorLib";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { renderCountryOptions } from "../libs/formsLib";
import config from '../config';


export default function TokenList({show, showTicket, showLocation, onClose, ...props}) {

    const [ticket, setTicket] = useState(null);
    const [showAdmission, setShowAdmission] = useState(false) 
    const [searchResults, setSearchResults] = useState([])
    const [selectedResult, setSelectedResult] = useState(null)
    const [status, setStatus] = useState('loading');
    const [isLoading, setIsLoading] = useState(false); 

    const [fields, handleFieldChange, resetFields] = useFormFields({    
      selectedTicket: "none",
      search: ""
    });

    async function getSearchResults(show) {
        const searchQuery = fields.search ? `&search=${fields.search}` : ''
        const query = `/etickets/tokens?show=${show._id}${searchQuery}`
        const results = await API.get("vivelo", query);
        if (results && results?.codes) {
            setSearchResults(results.codes)
            // setTotalRows(results.total || 0)
            return results.codes
        } else {
            setSearchResults([])
        }
        return []
    }

    async function validateCode(show_uid, code) {
        try {            
            const tokens = '&tokens=1'
            const result = await API.get("vivelo", `/etickets/tokens/redeem/${code}?s=${show_uid}${tokens}`);
            return result
        } catch (e) {
            console.log(e)
            return {
                success: false,
                allow_access: false
            }
        }
    }
    
    async function handleValidate(code) {
        setStatus('validating')

        const show_uid = show._id        
        const result = await validateCode(show_uid, code.code.split('-')[1])

        if (result.success) {
            setStatus('accepted')
                
            selectedResult.balance = result.balance
            selectedResult.logs = result.logs                

            setSelectedResult({ ... selectedResult })            
        } else {            
            setStatus('rejected')            

            setSelectedResult({ ... selectedResult })            
        }
    }

    function handleShowAdmission() {
        setTicket(null)
        setStatus('loading')
        setShowAdmission(!showAdmission)
    }  
    
    function exitScanner() {
        setTicket(null)
        setStatus('loading')
        onClose()
    }

    function renderStatusBar() {
        switch(status) {
            case 'scanning':
                return <Alert variant="info"><FontAwesomeIcon icon={faQrcode} /> Acerca el código a la cámara</Alert>
            case 'validating':
                return <Alert variant="primary"><FontAwesomeIcon icon={faSpinner} className="spinning" /> Validando...</Alert>
            case 'accepted':
                return <Alert variant="success"><FontAwesomeIcon icon={faCheckCircle} /> Canje exitoso</Alert>
            case 'warning':
                return <Alert variant="warning"><FontAwesomeIcon icon={faExclamationTriangle} /> Existe un problema con el token</Alert>
            case 'rejected':
                return <Alert variant="danger"><FontAwesomeIcon icon={faTimesCircle} /> Canje inválido</Alert>
            default: 
                return <></>
        }
    }

    function buildResultTicketFilter(ticket) {
        let resultFilter = ['VENUE_OPEN','VENUE_SEAT','VENUE_TABLE_SEAT'].includes(ticket.ticket_type)
        if (showLocation) {
            console.log(ticket?.seat?.location_uid, ticket)
            resultFilter &= ticket?.seat?.location_uid == showLocation._id
        }

        return resultFilter
    }
    function buildResultCodeFilter(code) {
        let resultFilter = ['VENUE_OPEN','VENUE_SEAT','VENUE_TABLE_SEAT'].includes(code.ticket_type)
        if (showLocation) {
            console.log(code.location_uid)
            resultFilter &= code.location_uid == showLocation._id
        }

        return resultFilter
    }

    function renderSearchResults() {
        let list = <></>
        try {

            if (searchResults) {
                list = searchResults                                        
                    .map(r => {                        
                        const code = r.code.split('-')

                    return <div className="show-admission-search-result" onClick={() => { 
                        setSelectedResult(r)
                    }}>
                        <div className="search-result-secondary">Token #{code[1]}</div>                                             
                        <div className="search-result-main">Disponible: {r.balance}</div>
                        <div className="search-result-secondary">Limite: {r.credits}</div>
                    </div>
                })
            }

            return <div className="show-admission-search-result-list">
                {list.length > 0 ? list : null}
            </div>

        } finally {
        }
    }

    function renderOrderTickets(code) {

        const logs = code.logs
            .map(log => {
                const date = moment(log.timestamp).format('LLL')                
                return <div className="ticket-data">                            
                    <div className="ticket-data-item"><label>Fecha</label><span>{date}</span></div>
                    <div className="ticket-data-item"><label>Saldo</label><span>{log.tokens}</span></div>
                </div>
            })

        return <div className={`ticket `} >                 
                {logs}
                { code.balance > 0 && 
                <div className="ticket-data">
                <Button onClick={() => { handleValidate(code) }}>Canjear</Button>
                </div>}
                {/* { vcode ? (checkedin 
                    ? <div className="ticket-data accepted">
                        <div className="ticket-data-item" style={{fontWeight:'bold'}}>ADMITIDO</div>
                        <div className="ticket-data-item"><label>Hora</label><Moment format='LLL' locale="es" style={{fontSize: 10}}>{checkedin}</Moment></div>                            
                    </div>
                    : <div className="ticket-data">
                    <Button onClick={() => { handleValidate(ticket, vcode) }}>Validar</Button>
                    </div> ) 
                    : <div className="ticket-data"><Badge variant="danger">INVÁLIDO</Badge></div>
                }  */}
                
            </div>        
        
    }

    function renderLoading() {
        return <div style={{color:'red', height:100}}><Loader /></div>
    }

    function handleSearchSubmit(e) {
        e.preventDefault();
        try {
            setIsLoading(true)

            setSearchResults([])
            getSearchResults(show)
        } finally {
            setIsLoading(false)
        }
    }
    function renderAdmissionList() {
        
        return show && <div className="scanner-container">
                <h1>Admisión por Listado</h1>
                
                {(showTicket || showLocation) && <div className="show-admission list-layout">
                    <div className="show-admission-header">                        
                        <h1>{show.fullname}</h1>
                        <Button onClick={exitScanner} className="exit" variant="outline-light">Cerrar</Button>
                        <h2>{showTicket.fullname}</h2>
                    </div>
                    
                    { !selectedResult && <div className={`show-admission-list`}>
                        <div className="show-admission-list-header">                            
                        {/* <form onSubmit={(e) => { e.preventDefault(); getSearchResults(show) }}> */}
                        <form onSubmit={handleSearchSubmit}>
                            <input type="text" 
                            value={fields.search}
                            name="search"
                            id="search"
                            onChange={handleFieldChange} /><Button type="submit">Buscar</Button>
                        </form>  
                        </div>
                        <div>
                            {isLoading ? renderLoading() : renderSearchResults()}
                        </div>
                    </div> }
                    { selectedResult && <div className={`show-admission-result `}>
                        <div className="show-admission-result-back">
                            <a href="#" onClick={() => {
                                setStatus(null)
                                setSelectedResult(null)
                            }}><FontAwesomeIcon icon={faChevronLeft} /> Regresar</a>
                            {renderStatusBar()}
                        </div>
                        <div className="show-admission-result-info">
                            <div>Token #{selectedResult.code.split('-')[1]}</div>
                            <div style={{fontWeight:'bold'}}>{`Disponible: ${selectedResult.balance} `}</div>
                            <div >{`Límite: ${selectedResult.credits} `}</div>
                        </div>
                        <div className="show-admission-result-tickets">
                        { renderOrderTickets(selectedResult) }
                        </div>
                        <div style={{height: 200}}></div>
                    </div> }
                </div> }
        </div>
    }
    
    return (        
        

        show ? <>    
            <div>
                    {renderAdmissionList()}
            </div>
        </> : null
  );


}